import { Button, ButtonVariant } from "@merge-api/merge-javascript-shared";
import { IntegrationEditorTopControlPanelActionProps } from "../../../models/Blueprints";

const IntegrationEditorTopControlPanelAction = ({
  Icon,
  isEnvironmentHighlighted,
  isDisabled,
  isLoading,
  onClick,
  text,
}: IntegrationEditorTopControlPanelActionProps & { isEnvironmentHighlighted?: boolean }) => {
  return (
    <Button
      variant={ButtonVariant.TextBlack}
      disabled={isDisabled}
      loading={isLoading}
      className={
        isEnvironmentHighlighted
          ? "text-black hover:enabled:bg-orange-10 focus-visible:bg-orange-10 disabled:bg-transparent disabled:text-gray-70"
          : undefined
      }
      onClick={() => {
        if (!isDisabled && !isLoading) {
          onClick();
        }
      }}
      leftIcon={<Icon size="12px" />}
    >
      {text}
    </Button>
  );
};

export default IntegrationEditorTopControlPanelAction;
